import { updateAssignment as updateAssignmentAPI } from "../api";

export const updateAssignmentAction = async (assignmentID, assignmentObject, setAssignment) => {
  const assignment = await updateAssignmentAPI(assignmentID, assignmentObject);
  setAssignment(assignment.data);
};
